var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37757 2.70757V0.577825C9.37757 0.0980531 9.9078 -0.160361 10.268 0.108643L10.3297 0.161651L14.8268 4.58283C15.0367 4.78916 15.0558 5.12058 14.8841 5.34968L14.8269 5.41512L10.3298 9.83772C9.99197 10.1699 9.4429 9.95663 9.38294 9.50392L9.37757 9.42161V7.32611L9.11989 7.34926C7.31965 7.54174 5.59416 8.37283 3.93261 9.85643C3.54318 10.2042 2.94067 9.87538 3.00472 9.3501C3.50344 5.25989 5.59039 3.00547 9.15299 2.72268L9.37757 2.70757ZM2.5 1C1.11929 1 0 2.11929 0 3.5V11.5C0 12.8807 1.11929 14 2.5 14H10.5C11.8807 14 13 12.8807 13 11.5V10.5C13 10.2239 12.7761 10 12.5 10C12.2239 10 12 10.2239 12 10.5V11.5C12 12.3284 11.3284 13 10.5 13H2.5C1.67157 13 1 12.3284 1 11.5V3.5C1 2.67157 1.67157 2 2.5 2H5.5C5.77614 2 6 1.77614 6 1.5C6 1.22386 5.77614 1 5.5 1H2.5Z",
    fill: "#5679EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.76e65109.svg";
export { ForwardRef as ReactComponent };